import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';

class ForeignCompanyGeneralInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {error: {}};
		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this)
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({error: result.error});
		return result;
	}

	render() {
		return (
			<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
				{this.props.externalCustomer.buyerType === "OZEL" &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Adı {this.props.externalCustomer.buyerType === "OZEL" ? "*" : ""}</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('tGivenName')}>
							<input className="form-control"
								   type="text"
								   name="givenName"
								   id="tGivenName"
								   ref="tGivenName"
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}
								   data-vlength={this.props.externalCustomer.buyerType === "OZEL" ? "1,45" : "0,45"}
								   onBlur={this.validateField}
								   value={this.props.externalCustomer.givenName}/>
							{this.validateMessage('tGivenName') !== "" &&
							<UncontrolledTooltip placement="right" target="tGivenName" delay={0}>
								{this.validateMessage("tGivenName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
				}

				{this.props.externalCustomer.buyerType === "OZEL" &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Soyadı {this.props.externalCustomer.buyerType === "OZEL" ? "*" : ""}</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('tFamilyName')}>
							<input className="form-control"
								   type="text"
								   name="familyName"
								   id="tFamilyName"
								   ref="tFamilyName"
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}
								   data-vlength={this.props.externalCustomer.buyerType === "OZEL" ? "1,45" : "0,45"}
								   onBlur={this.validateField}
								   value={this.props.externalCustomer.familyName}/>
							{this.validateMessage('tFamilyName') !== "" &&
							<UncontrolledTooltip placement="right" target="tFamilyName" delay={0}>
								{this.validateMessage("tFamilyName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
				}

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Resmi Unvan {this.props.externalCustomer.buyerType === "TUZEL" ? "*" : ""}</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('tFormattedName')}>
							<input className="form-control"
								   type="text"
								   name="formattedName"
								   id="tFormattedName"
								   ref="tFormattedName"
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}
								   data-vlength={this.props.externalCustomer.buyerType === "TUZEL" ? "1,255" : "0,255"}
								   onBlur={this.validateField}
								   value={this.props.externalCustomer.formattedName}/>
							{this.validateMessage('tFormattedName') !== "" &&
							<UncontrolledTooltip placement="right" target="tFormattedName" delay={0}>
								{this.validateMessage("tFormattedName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Firma Adı {this.props.externalCustomer.buyerType === "TUZEL" ? "*" : ""}</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('tTitle')}>
							<input className="form-control"
								   type="text"
								   name="title"
								   id="tTitle"
								   ref="tTitle"
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}
								   data-vlength={this.props.externalCustomer.buyerType === "TUZEL" ? "1,255" : "0,255"}
								   onBlur={this.validateField}
								   value={this.props.externalCustomer.title}/>
							{this.validateMessage('tTitle') !== "" &&
							<UncontrolledTooltip placement="right" target="tTitle" delay={0}>
								{this.validateMessage("tTitle")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Alıcı Türü *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('buyerType')}>
							<Select id="buyerType"
									name="buyerType"
									placeholder="Seçiniz..."
									value={this.props.externalCustomer.buyerType === null ? this.props.onChangeExternalCustomer({
										target: {
											name: "buyerType",
											value: "OZEL"
										}
									}) : this.props.externalCustomer.buyerType}
									clearable={false}
									noResultsText="Kayıt bulunamadı."
									onChange={(e) => e && this.props.onChangeExternalCustomer({target: {name: "buyerType", value: e.value}})}
									options={[{value: "OZEL", label: "Özel"}, {value: "TUZEL", label: "Tüzel"}]}
							/>
							{this.validateMessage('buyerType') !== "" &&
							<UncontrolledTooltip placement="right" target="buyerType" delay={0}>
								{this.validateMessage("buyerType")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Yabancı VKN *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass('tVknTckn')}>
							<input className="form-control"
								   maxLength={this.props.externalCustomer.buyerType === "TUZEL" ? "10" : "11"}
								   type="text"
								   name="vknTckn"
								   id="tVknTckn"
								   data-vlength={this.props.externalCustomer.buyerType === "TUZEL" ? "10,10" : "11,11"}
								   ref="tVknTckn"
								   onBlur={this.validateField}
								   value={this.props.externalCustomer.vknTckn}
								   onKeyPress={(e) => {
									   if (!/[0-9]/.test(e.key)) {e.preventDefault()}
								   }}
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							{this.validateMessage('tVknTckn') !== "" &&
							<UncontrolledTooltip placement="right" target="tVknTckn"
												 delay={0}>
								{this.validateMessage("tVknTckn")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ForeignCompanyGeneralInfo;